export default function RevertArrowIcon({ width = 14, height = 14, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} fill='none' viewBox='0 0 14 14' {...props}>
      <g stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
        <path d='M7.875 12.8333C8.99988 12.8333 10.0995 12.4998 11.0348 11.8748C11.9701 11.2499 12.6991 10.3616 13.1296 9.32235C13.56 8.28309 13.6727 7.13952 13.4532 6.03626C13.2338 4.93299 12.6921 3.91957 11.8967 3.12416C11.1013 2.32875 10.0878 1.78707 8.98458 1.56762C7.88131 1.34816 6.73774 1.4608 5.69849 1.89127C4.65923 2.32174 3.77097 3.05072 3.14602 3.98603C2.52107 4.92133 2.1875 6.02095 2.1875 7.14583V7.58333' />
        <path d='M0.4375 5.83158L2.1875 7.58158L3.9375 5.83158' />
      </g>
    </svg>
  );
}
